import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthService {
	#http = inject(HttpClient);
	#check?: Promise<boolean>;

	checkAuth(): Promise<boolean> {
		return (this.#check ??= this.#validateCookie());
	}

	async #validateCookie(): Promise<boolean> {
		if (!environment.enableAuth) {
			return true;
		}

		const post = (url: string) =>
			firstValueFrom(this.#http.post(url, {}, { withCredentials: true }));

		try {
			await Promise.any([
				post(environment.apiUrl + 'manager/valideCookie'),
				post(environment.partnerApiUrl + 'valideCookie'),
			]);
			return true;
		} catch {
			return false;
		}
	}
}
